
<h4 class="text-center mb-2">Liste des présence effectuées

    <a  type="button" class="btn btn-sm btn-danger float-md-end" routerLink="/professor-module/attendance-create">Faire l'appel</a>
</h4>
<div class="row">
    <div class="col-12">
        <div class=" text-center border" >
            <div class="ag-bg-red  row no-gutters p-1" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <div class="col-md-1 col-12">
                    <span class="text-white align-self-center">#</span>
                </div>
                <div class="col-md-7 col-12 text-start">
                    <span class="text-white align-self-center">Libellé</span>
                </div>
                <div class="col-md-3 col-12">
                    <span class="text-white align-self-center">Etat</span>
                </div>
                <div class="col-md-1 col-12">
                    <span class="text-white align-self-center">Action</span>
                </div>
            </div>
              
            <div class="" style="height: 65vh; overflow-y: scroll; overflow-x: hidden; ">
                <table class="table">
                    <tr class="row" *ngFor="let d of data; let i=index">
                        <td class="col-md-1 col-12">
                            <div class="">
                                {{i+1}}
                            </div>
                        </td>
                        <td class="col-md-7 col-12 text-start">
                            {{d.name}}
                        </td>
                        <td class="col-md-3 col-12">
                            <span class="badge-warning" *ngIf="!d.is_active">En attente de validation</span>
                            <span class="badge-success" *ngIf="d.is_active">Validé</span>
                        </td>
                        <td class="col-md-1 col-12">
                            <button class="btn btn-sm btn-success" (click)="showDetails(d.code)"><i class="fa fa-eye"></i></button>
                        </td>
                    </tr>
                </table>
                
            </div>
        </div>
    </div>
</div>